import { createContext } from 'react';
export var navHistoryContextDefaultValue = {
    navHistory: [],
    addHistory: function () { return undefined; },
    navigateAndAddHistory: function (_path) { return undefined; },
    removeLastPath: function () { return undefined; },
    navigateToPreviousPath: function (_defaultPath) { return undefined; },
};
export var NavHistoryContext = createContext(navHistoryContextDefaultValue);
